import axios from 'axios'
import { getToken } from 'services/amplify/auth'
import convertKeys from 'utils/convert-keys'

export const consumerApiAxiosInstance = (token, headers = {}) =>
  axios.create({
    baseURL: process.env.REACT_APP_CONSUMER_API_BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
      ...headers,
    },
  })

export const fetchJackpotPrizes = async () => {
  const token = await getToken()
  const response = await consumerApiAxiosInstance(token).get('/pledge/prizes')
  return convertKeys.toCamel(response.data)
}

export const fetchJackpotPledge = async () => {
  const token = await getToken()
  const response = await consumerApiAxiosInstance(token).get('/pledge')
  return convertKeys.toCamel(response.data)
}

export const requestJackpotPledge = async (requestPayload) => {
  const token = await getToken()
  const response = await consumerApiAxiosInstance(token).post('/pledge', requestPayload)
  return convertKeys.toCamel(response.data)
}

export const updateJackpotPledge = async (requestPayload) => {
  const token = await getToken()
  const response = await consumerApiAxiosInstance(token).put('/pledge', requestPayload)
  return convertKeys.toCamel(response.data)
}

export const deleteJackpotPledge = async () => {
  const token = await getToken()
  const response = await consumerApiAxiosInstance(token).delete('/pledge')
  return convertKeys.toCamel(response.data)
}
